"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadPolicyExtension = void 0;
var UploadPolicyExtension;
(function (UploadPolicyExtension) {
    UploadPolicyExtension["Png"] = "png";
    UploadPolicyExtension["Jpg"] = "jpg";
    UploadPolicyExtension["Jpeg"] = "jpeg";
    UploadPolicyExtension["Csv"] = "csv";
    UploadPolicyExtension["VndMsExcel"] = "vnd.ms-excel";
    UploadPolicyExtension["VndOpenXML"] = "vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    UploadPolicyExtension["Mov"] = "mov";
    UploadPolicyExtension["Mp4"] = "mp4";
    UploadPolicyExtension["Zip"] = "zip";
    UploadPolicyExtension["XZipCompressed"] = "x-zip-compressed";
    UploadPolicyExtension["QuickTime"] = "quicktime";
})(UploadPolicyExtension = exports.UploadPolicyExtension || (exports.UploadPolicyExtension = {}));
//# sourceMappingURL=upload-policy-extension.js.map